const API_BASE = process.env.REACT_APP_API_URL || '';

const getAuthHeader = () => {
  const token = localStorage.getItem('fb_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'An error occurred');
  return data;
};

export const signup = async (email, username, password) => {
  const r = await fetch(`${API_BASE}/api/auth/signup`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, username, password }) });
  return handleResponse(r);
};

export const login = async (email, password) => {
  const r = await fetch(`${API_BASE}/api/auth/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
  return handleResponse(r);
};

export const checkEmailExists = async (email) => {
  const r = await fetch(`${API_BASE}/api/auth/check-email`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
  return handleResponse(r);
};

export const requestPasswordReset = async (email) => {
  const r = await fetch(`${API_BASE}/api/auth/reset-password`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
  return handleResponse(r);
};

export const getMe = async () => {
  const r = await fetch(`${API_BASE}/api/auth/me`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const updateSettings = async (data) => {
  const r = await fetch(`${API_BASE}/api/auth/settings`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(data) });
  return handleResponse(r);
};

export const updateAvatar = async (formData) => {
  const r = await fetch(`${API_BASE}/api/auth/avatar`, { method: 'POST', headers: { ...getAuthHeader() }, body: formData });
  return handleResponse(r);
};

export const removeAvatar = async () => {
  const r = await fetch(`${API_BASE}/api/auth/avatar`, { method: 'DELETE', headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const getUserOrders = async () => {
  const r = await fetch(`${API_BASE}/api/auth/orders`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const getTopUpHistory = async () => {
  const r = await fetch(`${API_BASE}/api/auth/topup-history`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const getSiteConfig = async () => {
  const r = await fetch(`${API_BASE}/api/site-config`);
  return handleResponse(r);
};

export const getLivePurchases = async () => {
  const r = await fetch(`${API_BASE}/api/live-purchases`);
  return handleResponse(r);
};

export const getStock = async () => {
  const r = await fetch(`${API_BASE}/api/get-stock`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const validateInvite = async (invite) => {
  const r = await fetch(`${API_BASE}/api/validate-invite`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ invite }) });
  return handleResponse(r);
};

export const checkCoupon = async (coupon) => {
  const r = await fetch(`${API_BASE}/api/check-coupon`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify({ coupon }) });
  return handleResponse(r);
};

export const createOrder = async (orderData) => {
  const r = await fetch(`${API_BASE}/api/create-order`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(orderData) });
  return handleResponse(r);
};

export const createStripeSession = async (orderData) => {
  const r = await fetch(`${API_BASE}/api/create-stripe-session`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(orderData) });
  return handleResponse(r);
};

export const getOrder = async (orderId) => {
  const r = await fetch(`${API_BASE}/api/order/${orderId}`);
  return handleResponse(r);
};

export const getCheckout = async (orderId) => {
  const r = await fetch(`${API_BASE}/api/checkout/${orderId}`);
  return handleResponse(r);
};

export const getPaymentStatus = async (orderId) => {
  const r = await fetch(`${API_BASE}/api/payment-status/${orderId}`);
  return handleResponse(r);
};

export const getApiKey = async () => {
  const r = await fetch(`${API_BASE}/api/auth/api-key`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const regenerateApiKey = async () => {
  const r = await fetch(`${API_BASE}/api/auth/api-key/regenerate`, { method: 'POST', headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const testApiKey = async (endpoint) => {
  const r = await fetch(`${API_BASE}/api/auth/api-key/test`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify({ endpoint }) });
  return handleResponse(r);
};

export const getNotificationPrefs = async () => {
  const r = await fetch(`${API_BASE}/api/auth/notifications`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const updateNotificationPrefs = async (prefs) => {
  const r = await fetch(`${API_BASE}/api/auth/notifications`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(prefs) });
  return handleResponse(r);
};

export const subscribeRestockNotify = async (productId, email) => {
  const r = await fetch(`${API_BASE}/api/restock-notify`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify({ productId, email }) });
  return handleResponse(r);
};

export const getTickets = async () => {
  const r = await fetch(`${API_BASE}/api/auth/tickets`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const createTicket = async (formData) => {
  const r = await fetch(`${API_BASE}/api/auth/tickets`, { method: 'POST', headers: { ...getAuthHeader() }, body: formData });
  return handleResponse(r);
};

export const getTicketMessages = async (ticketId) => {
  const r = await fetch(`${API_BASE}/api/auth/tickets/${ticketId}/messages`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const sendTicketMessage = async (ticketId, formData) => {
  const r = await fetch(`${API_BASE}/api/auth/tickets/${ticketId}/messages`, { method: 'POST', headers: { ...getAuthHeader() }, body: formData });
  return handleResponse(r);
};

export const closeTicket = async (ticketId) => {
  const r = await fetch(`${API_BASE}/api/auth/tickets/${ticketId}/close`, { method: 'POST', headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const validateResetToken = async (token) => {
  const r = await fetch(`${API_BASE}/api/auth/reset-password/${token}`);
  const data = await r.json();
  return data;
};

export const resetPassword = async (token, password) => {
  const r = await fetch(`${API_BASE}/api/auth/reset-password/${token}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password }) });
  const data = await r.json();
  return data;
};

export const getApiTasks = async () => {
  const r = await fetch(`${API_BASE}/api/auth/api-tasks`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const checkRestockStatus = async (productId, email) => {
  const r = await fetch(`${API_BASE}/api/restock-notify/status?productId=${productId}&email=${encodeURIComponent(email)}`);
  return handleResponse(r);
};

// === Top Up / Balance ===
export const getBalance = async () => {
  const r = await fetch(`${API_BASE}/api/auth/balance`, { headers: { ...getAuthHeader() } });
  return handleResponse(r);
};

export const createTopup = async (data) => {
  const r = await fetch(`${API_BASE}/api/auth/topup`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(data) });
  return handleResponse(r);
};

export const createTopupStripe = async (data) => {
  const r = await fetch(`${API_BASE}/api/auth/topup-stripe`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(data) });
  return handleResponse(r);
};

export const createBalanceOrder = async (orderData) => {
  const r = await fetch(`${API_BASE}/api/create-balance-order`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeader() }, body: JSON.stringify(orderData) });
  return handleResponse(r);
};